

import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Admin/Sidebar";

const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  // Update isDesktop on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      {/* Main Content */}
      <div
        className="flex-grow-1"
        style={{
          marginLeft: isDesktop ? (collapsed ? "80px" : "260px") : "0",
          transition: "margin-left 0.3s",
          padding: "20px",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;




